import { useContext, useState } from "react"
import { OffCanvas } from "../OffCanvas"
import { GlobalContext } from "../../context/GlobalContext"
import { OrderContext } from "../../context/OrderContext"
import { useDispatch, useSelector } from "react-redux"
import { CLEAR_SELECT_ORDER, UPDATE_ORDER, UPDATE_SELECT_ORDER } from "../../stores/reducers/OrderReducers"
import { Btn } from "../Btn"
import { IoIosArrowForward } from "react-icons/io"
import { BsCreditCard2Back } from "react-icons/bs"
import { LuCirclePlus, LuPackageCheck, LuPackagePlus, LuReceipt } from "react-icons/lu"
import { maskCurrency } from "../../utils/utils"
import * as T from "../Tables/styles"
import { Toast } from "../../utils/Toast"
import { FiUserPlus } from "react-icons/fi"
import { CustomItemCard } from "../CustomItemCard"
import { FaCheck, FaRegTrashCan } from "react-icons/fa6"
import { HiOutlinePrinter } from "react-icons/hi"
import { sendPrint } from "../../reporting/print"
import _ from "lodash"
import { AllPayments } from "../Modals/Orders/components/AllPayments"
import { NewAddProduct } from "../Modals/Orders/components/NewAddProduct"
import { CustomerForm } from "../Forms/Customer"
import { api } from "../../api/api"
import { MdClose } from "react-icons/md"
import './style.css'
import { OrderOverview } from "./OrderOverview"
import { OrderFiscalButton } from "./OrderFiscalButton"
import { LIST_STATUS } from '../../utils/constantes'

let isRequest = false

export function OrderDeliveryOffCanvas({ isOffCanvasOpen, toggleOffCanvas }) {
  const { isAccess } = useContext(GlobalContext)
  const {
    orderScreen,
    changeOrderScreen, addProductsToConfirmationList, listProductsAdd,
    setListProductsAdd, calculateTotal, update
  } = useContext(OrderContext)

  const {
    user
  } = useContext(GlobalContext)

  const dispatch = useDispatch()
  const [customerDirty, setCustomerDirty] = useState(false)

  const order = useSelector(state => state.order?.orderSelect)

  async function confirmDiscardCustomerChanges() {
    if (!orderScreen.customer || !customerDirty) return true

    return Toast.confirm(
      'Existem alterações no cliente que não foram salvas. Deseja descartá-las?',
      'Continuar editando',
      'Descartar'
    )
  }

  async function handleChangeOrderScreen() {
    if (!await confirmDiscardCustomerChanges()) return

    if (orderScreen.listProducts || orderScreen.customer || orderScreen.closeOrder) {
      setCustomerDirty(false)
      changeOrderScreen('default')
    } else if (orderScreen.addProducts) {
      changeOrderScreen('listProducts')
    }
  }

  async function removeProduct(id) {
    const newOrder = {
      ...order,
      productsOrders: order?.productsOrders.filter((e) => e.id !== id),
    }

    const totalUpdated = calculateTotal(newOrder)

    const payload = {
      ...newOrder,
      total: totalUpdated
    }

    await sendPrint('cancel-product-order', { product: order?.productsOrders.find((e) => e.id === id) }, order?.id)

    dispatch(UPDATE_ORDER(payload))

    await update(false, true, payload)
  }

  async function addProduct(dataProducts = [], { print }) {
    try {
      if (!isAccess('pedidos', 'update')) {
        return Toast.warning('Você não tem permissão para atualizar pedido')
      }

      if (!Array.isArray(dataProducts) || dataProducts.length === 0) {
        return;
      }

      if (isRequest) {
        return Toast.warning('Aguarde um momento, estamos salvando a informação.')
      }

      if (order?.status === 'cancelado') return Toast.warning('Comanda cancelada, não é possível realizar ações para a mesma')

      isRequest = true

      dataProducts = dataProducts.map((v) => {
        return {
          ...v,
          isPrinted: false,
          isSeen: false
        }
      })

      const newProducts = [...order?.productsOrders ?? [], ...dataProducts]

      const newOrder = {
        id: order?.id,
        productsOrders: newProducts
      }

      const totalUpdated = calculateTotal(newOrder)

      const payload = {
        ...newOrder,
        total: totalUpdated
      }

      dispatch(UPDATE_ORDER(payload))
      const next = await update(false, true, payload)

      isRequest = false

      // se não for continuar pq deu erro em algo pra que vou imprimir essa buceta?
      if (next) {
        if (print && user.isPrint) {
          await sendPrint('product-order', { dataProducts }, order?.id)
        }
      }

      setListProductsAdd([])
    } catch (error) {
      isRequest = false
    }
  }

  function canculateUnitProduct(productOrder) {
    let additinalTotals = 0
    if (Object.keys(productOrder?.additinal).length) {
      additinalTotals = Object.keys(productOrder?.additinal).reduce((prev, key) => {
        const value = productOrder?.additinal[key].reduce((prevAditional, current) => prevAditional += (current.pricing * current.quantity), 0)

        prev += value
        return prev
      }, 0)
    }

    return productOrder?.pricing + additinalTotals
  }

  async function closeOrCancelOrder(cancel = false) {
    const confirmation = await Toast.confirm(`Deseja ${cancel ? 'Cancelar' : 'Finalizar'} o pedido?`, "Não", "Sim")

    if (confirmation) {

      if (cancel) {
        if (isAccess('pedidos', 'cancelar_pedido')) {
          await sendPrint('cancel-order', {}, order?.id)
          await api.put('/orders/' + order?.id, { status: 'cancelado' })
        } else {
          return Toast.warning('Você não tem permissão para cancelar pedido')
        }
      } else {
        if (isAccess('pedidos', 'update')) {
          await api.put('/orders/' + order?.id, { status: 'finalizado' })
        } else {
          return Toast.warning('Você não tem permissão para atualizar pedido')
        }
      }

      Toast.success(`Pedido ${cancel ? 'cancelado' : 'finalizado'} com sucesso`)

      toggleOffCanvas()
      changeOrderScreen('default')
    }
  }

  async function setSeen(id) {
    await api.put('/product-order/set-seen-printed', { ids: [id] })

    dispatch(UPDATE_SELECT_ORDER({
      productsOrders: order?.productsOrders.map(x => {
        if (x.id === id) {
          return {
            ...x,
            isSeen: true
          }
        }
        return x
      })
    }))
  }

  function clearAll() {
    dispatch(CLEAR_SELECT_ORDER())
    toggleOffCanvas()
    changeOrderScreen('default')
    setListProductsAdd([])
    setCustomerDirty(false)
  }

  async function requestClose() {
    if (!await confirmDiscardCustomerChanges()) return

    if (listProductsAdd.length > 0) {
      const confirmation = await Toast.confirm('Existem itens ainda não confirmados. Deseja descartá-los?', 'Continuar editando', 'Descartar')
      if (!confirmation) return
    }

    clearAll()
  }


  const isCancelable = order?.id ? (order.typeOrder !== 'mesa' && !['finalizado', 'cancelado'].includes(order.status)) : false

  if (!order || !order?.status)
    return <></>;

  return (
    <>
      <OffCanvas
        isModal
        width={'1180px'}
        paddingBody={orderScreen ? '0' : '1rem'}
        expanded={isOffCanvasOpen}
        onClose={requestClose}
        titleIcon={<LuReceipt size={20} />}
        title={orderScreen.default ? `Pedido ${order?.numOrder ? `#${order.numOrder}` : ''}` : orderScreen.listProducts || orderScreen.addProducts ? 'Adicionar itens' : orderScreen.customer ? 'Cliente e endereço' : 'Pagamento'}
        subtitle={orderScreen.default ? `${order?.name || 'Pedido sem cliente'} · ${LIST_STATUS.find(e => e.status === order.status)?.name || order.status || ''}` : orderScreen.customer ? 'Edite os dados e clique em Salvar alterações' : 'As alterações são aplicadas ao pedido selecionado'}
        clearValues={() => console.log('clearValues')}
        footer={
          <div className="order-editor-footer">
            <div>
              {!orderScreen.default && (
                <Btn
                  text={'Voltar'}
                  click={() => handleChangeOrderScreen()}
                  icon={<IoIosArrowForward size={18} color="#94a3b8" style={{ transform: 'rotateY(180deg)' }} />}
                  leftIcon
                />
              )}
            </div>

            <div>
              {orderScreen.default && (
                <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', }}>
                  {isCancelable && (
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#modalRefusedOrder"
                      onClick={() => console.log(order)}
                      style={{
                        backgroundColor: 'red',
                        border: 'none',
                        color: 'white',
                        borderRadius: 8,
                        fontWeight: 600,
                      }}
                    >
                      <MdClose size={17} /> Cancelar pedido
                    </button>
                  )}

                  <Btn
                    text={'Imprimir pedido'}
                    icon={<HiOutlinePrinter size={18} />}
                    leftIcon
                    click={() => sendPrint('order', {}, order?.id)}
                    width={170}
                  />

                  <OrderFiscalButton order={order} />

                  <Btn
                    text={'Lançar pagamento'}
                    backgroundColor='#ff6200'
                    hoverColor='#d55302'
                    color='white'
                    icon={<BsCreditCard2Back size={18} color="white" />}
                    leftIcon
                    disabled={(!order || ['cancelado', 'finalizado'].includes(order?.status)) ? true : false}
                    click={() => changeOrderScreen('closeOrder')}
                    width={200}
                  />
                </div>
              )}

              {orderScreen.addProducts && (
                <Btn
                  text={'Adicionar produto'}
                  backgroundColor='#ff6200'
                  hoverColor='#d55302'
                  color='white'
                  icon={<LuPackagePlus size={18} color="white" />}
                  leftIcon
                  disabled={!order ? true : false}
                  click={addProductsToConfirmationList}
                />
              )}

              {orderScreen.closeOrder && (
                <Btn
                  text={'Lançar no caixa'}
                  backgroundColor='#ff6200'
                  hoverColor='#d55302'
                  color='white'
                  icon={<LuPackagePlus size={18} color="white" />}
                  leftIcon
                  disabled={!order ? true : false}
                  click={() => closeOrCancelOrder()}
                />
              )}
            </div>

            {/* <Btn
              text={'Imprimir Prévia'}
              disabled={!selectTable?.commands?.length ? true : false}
            /> */}
          </div>
        }
      >
        {orderScreen.default && (
          <OrderOverview
            order={order}
            pendingProducts={listProductsAdd}
            calculateProductTotal={canculateUnitProduct}
            canEdit={!['cancelado', 'finalizado'].includes(order?.status)}
            onAddItems={() => changeOrderScreen('listProducts')}
            onEditCustomer={() => changeOrderScreen('customer')}
            onOpenPayments={() => changeOrderScreen('closeOrder')}
            onConfirmPending={() => addProduct(listProductsAdd, { print: true })}
            onRemovePending={async (id) => {
              const confirmation = await Toast.confirm('Deseja remover este item?', 'Não', 'Sim')
              if (confirmation) setListProductsAdd(listProductsAdd.filter(product => product.id !== id))
            }}
            onRemoveProduct={async (id) => {
              const confirmation = await Toast.confirm('Deseja remover este item do pedido?', 'Não', 'Sim')
              if (confirmation) await removeProduct(id)
            }}
            onPrintProduct={(product) => sendPrint('product-order', { dataProducts: [product] }, order?.id)}
            onSetSeen={setSeen}
          />
        )}

        {false && orderScreen.default && (
          <div className="order-editor-default delivery-order-editor">
            <div style={{ padding: '0 1rem' }}>
              <div style={{ padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#121428', borderRadius: '8px', }}>
                <div>
                  <p style={{ color: '#94a3b8', fontSize: '0.85rem', fontWeight: '700' }}>TOTAL</p>
                  <p style={{ color: 'white', fontSize: '1.5rem', fontWeight: '700' }}>{maskCurrency(order?.total || 0)}</p>
                </div>

              </div>
            </div>

            <div style={{ padding: '0px 1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                {!['cancelado', 'finalizado'].includes(order?.status) && (
                  <Btn text={'Lançar Itens'} icon={<LuCirclePlus size={18} color="#ff6200" />} leftIcon click={() => changeOrderScreen('listProducts')} />
                )}

                <Btn text={'Imprimir Prévia'} icon={<HiOutlinePrinter size={18} color="#334155" />} leftIcon click={async () => {
                  await sendPrint('order', {}, order?.id)
                }} />
              </div>

              <CustomItemCard
                titleWeight="500"
                maxWidth="auto"
                minWidth="auto"
                width="100%"
                margin="2rem 0 0 0"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                backgroundColor="#f8fafc"
                click={() => changeOrderScreen('customer')}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                }}>
                  <div style={{
                    width: 35,
                    height: 35,
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    border: '1px solid #dae2f0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                    <FiUserPlus size={20} color="#94a3b8" />
                  </div>

                  <div style={{ color: '#252424' }}>
                    <p className="title">Cliente</p>
                    <p className="subtitle">{order?.name}</p>
                  </div>
                </div>

                <div>
                  <IoIosArrowForward size={18} color="#94a3b8" />
                </div>
              </CustomItemCard>

              {listProductsAdd?.length && !['cancelado', 'finalizado'].includes(order?.status) ? (
                <>
                  <div style={{ width: '100%', marginTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ color: 'red', fontSize: '0.9rem', fontWeight: '600' }}>ITENS NÃO CONFIRMADOS ({listProductsAdd?.length || 0})</p>

                    <T.ContentNewComand $textColor={'#0db60d'} $hoverColor={'#128a12'} onClick={async () => await addProduct(listProductsAdd, { print: true })}>
                      <LuPackageCheck size={14} />
                      <p style={{ fontSize: '0.9rem', fontWeight: '600' }}>Confirmar Todos</p>
                    </T.ContentNewComand>
                  </div>

                  {_.orderBy(listProductsAdd, (a) => a.isSeen, 'asc')?.map(prod => (
                    <CustomItemCard
                      key={prod.id}
                      titleWeight="500"
                      maxWidth='auto'
                      minWidth='auto'
                      margin="1.3rem 0 0 0"
                      width="100%"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                      onConfirm={() => setListProductsAdd(listProductsAdd.filter((e) => e.id !== prod.id))}
                      initIcon={<FaRegTrashCan />}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                      }}>
                        <div style={{
                          width: 28,
                          height: 28,
                          borderRadius: '8px',
                          backgroundColor: '#f8fafc',
                          border: '1px solid #f1f5f9',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontWeight: 700,
                          color: '#475569'
                        }}>
                          {prod.quantity}x
                        </div>

                        <p className="subtitle" style={{ fontWeight: 600, color: '#334155' }}>{prod.name}</p>
                        <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.8rem', color: 'rgb(148, 163, 184)' }}>Unitário: <span style={{ fontWeight: 600 }}>{maskCurrency(prod.pricing)}</span></p>
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <p className="subtitle text-gray" style={{ fontWeight: 700 }}>{maskCurrency(prod.pricing * prod.quantity)}</p>

                        <HiOutlinePrinter size={window.screen.width < 500 ? 30 : 18} color="#7176f8" onClick={async () => await sendPrint('product-order', { dataProducts: [prod] }, order?.id)} />
                      </div>
                    </CustomItemCard>
                  ))}
                </>
              ) : ""}

              <div style={{ width: '100%', marginTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p style={{ color: '#94a3b8', fontSize: '0.9rem', fontWeight: '600' }}>ITENS ({order?.productsOrders?.length || 0})</p>

                {/* <T.ContentNewComand onClick={async () => await sendPrint('product-order', { dataProducts: order?.productsOrders }, order?.id)}>
                      <HiOutlinePrinter size={14} />
                      <p style={{ fontSize: '0.9rem', fontWeight: '600', lineHeight: '0' }}>Imprimir Produtos</p>
                    </T.ContentNewComand> */}
              </div>

              {order?.productsOrders?.map(productOrder => (
                <CustomItemCard
                  key={productOrder?.id}
                  titleWeight="500"
                  maxWidth='auto'
                  minWidth='auto'
                  margin="1.3rem 0 0 0"
                  width="100%"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                  onConfirm={() => removeProduct(productOrder?.id)}
                  initIcon={<FaRegTrashCan />}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}>
                    <div style={{
                      width: 28,
                      minWidth: 28,
                      height: 28,
                      minHeight: 28,
                      borderRadius: '8px',
                      backgroundColor: '#f8fafc',
                      border: '1px solid #f1f5f9',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 700,
                      color: '#475569'
                    }}>
                      {productOrder?.quantity}x
                    </div>

                    <div>
                      <p className="subtitle" style={{ fontWeight: 600, color: '#334155' }}>{productOrder?.name}</p>
                      <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.9rem', color: 'rgb(148, 163, 184)' }}>Unitário: <span style={{ fontWeight: 600 }}>{maskCurrency(productOrder?.pricing)}</span></p>

                      {Object.keys(productOrder?.additinal).length ? (
                        <div style={{ marginTop: '0.1rem' }}>
                          {Object.keys(productOrder?.additinal).map(additinalName => (
                            productOrder?.additinal[additinalName]?.map((additinal, idx) => (
                              <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }} key={idx}>
                                <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                  <span style={{ color: '#fead15' }}>+{additinal.quantity}</span>
                                </p>

                                <p className="subtitle" style={{ fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                  {additinal.name}
                                </p>

                                <p className="subtitle" style={{ fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                  {maskCurrency(additinal.pricing)}
                                </p>
                              </div>
                            ))
                          ))}
                        </div>
                      ) : ''}
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <p className="subtitle text-gray" style={{ fontWeight: 700 }}>{maskCurrency(canculateUnitProduct(productOrder) * productOrder?.quantity)}</p>

                    <HiOutlinePrinter size={window.screen.width < 500 ? 30 : 18} color="#7176f8" onClick={async () => await sendPrint('product-order', { dataProducts: [productOrder] }, order?.id)} />
                    {productOrder?.isSeen ? <FaCheck color="green" /> : <MdClose className="pointer" onClick={async () => await setSeen(productOrder?.id)} color="red" />}

                  </div>
                </CustomItemCard>
              ))}
            </div>
          </div>
        )}

        {(orderScreen.listProducts || orderScreen.addProducts) && (
          <NewAddProduct />
        )}

        {orderScreen.customer && (
          <CustomerForm onDirtyChange={setCustomerDirty} />
        )}
        {orderScreen.closeOrder && (
          <AllPayments />
        )}
      </OffCanvas>
    </>
  )
}
